module.exports = __webpack_public_path__ + "static/images/page-logo.7eaf044.png";